const esLang = {
  groupCompanies: 'Empresas del grupo',
  legals: 'Legales',
  codeOfEthics: 'Código de Ética',
  authorizationKeys: 'Claves de Autorización',
  noticeOfPrivacy: 'Aviso de Privacidad'
}
const enLang = {
  groupCompanies: 'Group companies',
  legals: 'Legals',
  codeOfEthics: 'Code of Ethics',
  authorizationKeys: 'Authorization Keys',
  noticeOfPrivacy: 'Notice of Privacy'
}

export const langTexts = {
  es: esLang,
  en: enLang
} 